<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Pré Fatura Despesa Agregado</h4>
              <span>* Campo transportadora é obrigatório</span><br />
              <span>* A transportadora deve ser do tipo agregado</span>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onStore()" v-b-tooltip title="Cadastrar"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('parambanco.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive" style="min-height: 500px">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                  <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('gerardoc.store')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/gerarprefaturadespesaagregado"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    pagination-path=""
                    track-by="docfis_id"
                    detail-row-component="gerar-pre-fatura-despesa-agregado-detalhes"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="dt_emi" slot-scope="props">
                      <span>{{ formatDate(props.rowData.dt_emissao) }}</span>
                    </template>
                    <template slot="num_ciot" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_doc_reentrega.length > 0 &&
                          props.rowData.carga_doc_reentrega[0].carga
                            .carga_ciot != null
                        "
                        >{{
                          props.rowData.carga_doc_reentrega[0].carga.carga_ciot
                            .ciot.ciot
                        }}</span
                      >
                    </template>
                    <template slot="dt_entrega" slot-scope="props">
                      <span v-if="props.rowData.data_entrega != null">
                        {{ formatDate(props.rowData.data_entrega) }}
                      </span>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          v-if="props.rowData.doc_fiscal_agr_log.length > 0"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import AvisoErros from "../components/AvisoErros";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import GerarPreFaturaDespesaAgregadoFilterBar from "./GerarPreFaturaDespesaAgregadoFilterBar.vue";
import GerarPreFaturaDespesaAgregadoDetalhes from "./GerarPreFaturaDespesaAgregadoDetalhes";
import moment from "moment";

Vue.component(
  "gerar-pre-fatura-despesa-agregado-detalhes",
  GerarPreFaturaDespesaAgregadoDetalhes
);

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": GerarPreFaturaDespesaAgregadoFilterBar,
  },
  data() {
    return {
      dataExport: [],
      errors_array: [],
      optionsTpOperacao: [],
      filter_data_store: {},
      filtros_form: new Form({
        transportadora: "",
        num_ciot: "",
        consulta_erros: "",
        dt_emissao_ini: "",
        dt_emissao_fim: "",
        dt_entrega_ini: "",
        dt_entrega_fim: "",
        tp_operacao: "",
        num_carga: "",
        tp_operacao: ""
      }),
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      transportadora: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ docfis: [], transportadora: 0, dt_entrega_ini: "", dt_entrega_fim: "" }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "N° NF",
          sortField: "num_fiscal",
        },
        {
          name: "serie",
          title: "Serie",
          sortField: "serie",
        },
        {
          name: "__slot:num_ciot",
          title: "N° Ciot",
          sortField: "num_ciot",
        },
        {
          name: "__slot:dt_emi",
          title: "Data de Emissão",
          sortField: "dt_emi",
        },
        {
          name: "__slot:dt_entrega",
          title: "Data da Entrega",
          sortField: "dt_entrega",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        console.log("this.filter_data_store");
        console.log(this.filter_data_store);
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.transportadora =
            this.filter_data_store.transportadora;
          this.filtros_form.num_carga =
            this.filter_data_store.num_carga;
          this.filtros_form.consulta_erros =
            this.filter_data_store.consulta_erros;
          this.filtros_form.dt_emissao_ini =
            this.filter_data_store.dt_emissao_ini;
          this.filtros_form.dt_emissao_fim =
            this.filter_data_store.dt_emissao_fim;
          this.filtros_form.dt_entrega_ini =
            this.filter_data_store.dt_entrega_ini;
          this.filtros_form.dt_entrega_fim =
            this.filter_data_store.dt_entrega_fim;
          this.filtros_form.num_ciot = this.filter_data_store.num_ciot;
          this.filtros_form.tp_operacao = this.filter_data_store.tp_operacao;
          this.filtros_form
            .post("/api/gerarprefaturadespesaagregado/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.$refs.vuetable.selectedTo = [];
      this.moreParams = {
        transportadora: data_filter.transportadora.pessoa_id,
        consulta_erros: data_filter.consulta_erros,
        dt_emissao_ini: data_filter.dt_emissao_ini,
        dt_emissao_fim: data_filter.dt_emissao_fim,
        dt_entrega_ini: data_filter.dt_entrega_ini,
        num_carga: data_filter.num_carga,
        dt_entrega_fim: data_filter.dt_entrega_fim,
        tp_operacao: data_filter.tp_operacao.value,
        num_ciot: data_filter.num_ciot,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    getLivGeral() {
      this.helpForm
          .get("/api/gerarprefaturadespesaagregado/jsonlist")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            response.tp_operacao.forEach((obj) => {
              this.optionsTpOperacao.push({
                label: obj.descr,
                value: obj.valor,
              });
            });
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.filter_data_store = {};
      this.$refs.vuetable.selectedTo = [];
      this.transportadora = "";
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      if (this.dataExport.length > 0) {
        this.dataExport.forEach((obj) => {
          obj.carga_ocorrencia.forEach((obj2) => {
            if (
              obj2.param_ocorrencia != null 
            ) {
              obj.data_entrega = obj2.dt_ocorrencia;
              return;
            }
          });
        });
      }
      this.$store.commit("setVuetableFilterButton", false);
    },
    onStore() {
      this.errors_array = "";
      this.errors_array = [];
      this.form.docfis = [];
      console.log(this.moreParams.transportadora);
      if(this.moreParams.transportadora != undefined ){
        this.transportadora = this.moreParams.transportadora;
      }
      if(this.moreParams.dt_entrega_ini != undefined){
        this.form.dt_entrega_ini = this.moreParams.dt_entrega_ini;
      }
      if(this.moreParams.dt_entrega_fim != undefined){
        this.form.dt_entrega_fim = this.moreParams.dt_entrega_fim;
      }
      this.form.transportadora = this.transportadora;
      this.loadingDataStore = true;
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form.docfis.push({ docfis_id: obj });
      });
      this.form
        .post("/api/gerarprefaturadespesaagregado/store")
        .then((response) => {
          new ReturnApi(response, this);
          console.log(this);
          this.docfis = [];
          this.loadingDataStore = false;
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onEdit(data, index) {
      this.id = data.parban_id;
      this.$refs.paramsform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox

      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.parban_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.paramsform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
